import '../css/SocialLinks.css';

const SocialLinks = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/MarcoConti91',
      icon: 'https://img.icons8.com/?size=100&id=118497&format=png',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/marconti91/',
      icon: 'https://img.icons8.com/?size=100&id=32323&format=png',
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/marco-c-aba1aa13a/',
      icon: 'https://img.icons8.com/?size=100&id=114445&format=png',
    },
    {
      name: 'Github',
      url: 'https://github.com/Beremas',
      icon: 'https://img.icons8.com/?size=100&id=63777&format=png',
    },
 
  ];

  return (
    <section className="socials">
      <header className="section-head">
        <span className="section-eyebrow">Say hello</span>
        <h1 className="section-title">Connect with me</h1>
        <p className="prose prose-muted socials-intro">
          Find me on any of these; LinkedIn and GitHub are where I answer fastest.
        </p>
      </header>

      <div className="socials-links">
        {socialLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="socials-link"
          >
            <img src={link.icon} alt="" className="socials-icon" loading="lazy" />
            <span className="socials-name">{link.name}</span>
          </a>
        ))}
      </div>
    </section>
  );
};

export default SocialLinks;
